import Http from "./http";

export const updateTermsAndConditionsStatusAPI = (payload, options) => {
  return Http.post("/admin/campaign/terms-condition/status", payload, options);
};

